
export default function HowWeOperate() {
  const principles = [
    {
      icon: 'ri-lock-line',
      title: 'Absolute Discretion',
      description: 'All engagements conducted under strict confidentiality protocols'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Bespoke Engagement Structures',
      description: 'Customized frameworks aligned with family office governance'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Elite Medical Personnel Only',
      description: 'Vetted professionals with high-stakes operational experience'
    },
    {
      icon: 'ri-file-forbid-line',
      title: 'No Templates, No Compromises',
      description: 'Every solution designed specifically for your exposure profile'
    },
    {
      icon: 'ri-team-line',
      title: 'Integrated Operations',
      description: 'Seamless coordination with security, aviation, and maritime teams'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Medical Security Partner',
      description: 'Strategic advisory role, not healthcare provider'
    }
  ];

  return (
    <section id="approach" className="bg-[#0A0A0A] py-16 sm:py-24 md:py-32">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <div className="text-[8px] sm:text-[9px] uppercase tracking-[0.2em] text-[#606060] font-light mb-3 sm:mb-4">
            How We Operate
          </div>
          <h2 className="text-[32px] sm:text-[42px] md:text-[56px] font-bold text-[#F0F0F0] leading-tight font-serif">
            Operational Principles
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16 md:mb-20">
          {principles.map((principle, index) => (
            <div
              key={index}
              className="bg-[#0F0F0F] border border-[#1A1A1A] rounded-2xl p-6 sm:p-8"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 flex items-center justify-center mb-4 sm:mb-5">
                <i className={`${principle.icon} text-[28px] sm:text-[32px] md:text-[40px] text-[#F5F5F5]`}></i>
              </div>
              <h3 className="text-base sm:text-lg md:text-[18px] font-semibold text-[#F5F5F5] mb-2 sm:mb-3">
                {principle.title}
              </h3>
              <p className="text-xs sm:text-sm md:text-[14px] text-[#A0A0A0] leading-relaxed">
                {principle.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-[#0F0F0F] border border-[#1A1A1A] rounded-2xl p-6 sm:p-8 md:p-10 lg:p-12">
          <h3 className="text-xl sm:text-2xl md:text-[32px] font-bold text-[#F5F5F5] mb-4 sm:mb-6 font-serif">
            Engagement Structure
          </h3>
          <p className="text-sm sm:text-base md:text-[16px] text-[#A0A0A0] leading-relaxed mb-4 sm:mb-6">
            Engagements are selectively accepted and structured as <strong className="text-[#F5F5F5]">strategic retainers or fixed-scope mandates</strong>, aligned with family office governance and risk frameworks.
          </p>
          <p className="text-sm sm:text-base md:text-[16px] text-[#A0A0A0] leading-relaxed mb-4 sm:mb-6">
            Typical engagements range from <strong className="text-[#F5F5F5]">six-figure annual retainers</strong> to <strong className="text-[#F5F5F5]">principal-level mandates exceeding seven figures</strong>, depending on exposure, geography, and operational complexity.
          </p>
          <p className="text-sm sm:text-base md:text-[16px] text-[#A0A0A0] leading-relaxed">
            Pricing is comparable to executive protection, aviation security, and intelligence services.
          </p>
        </div>

        <div className="mt-8 sm:mt-10 md:mt-12 text-center">
          <div className="inline-flex items-center gap-2 sm:gap-3 bg-[#0F0F0F] border border-[#1A1A1A] rounded-full px-4 sm:px-6 md:px-8 py-3 sm:py-4">
            <i className="ri-shield-check-line text-lg sm:text-xl md:text-[24px] text-[#F5F5F5]"></i>
            <span className="text-xs sm:text-sm md:text-[14px] text-[#F5F5F5] font-light">
              Discreet. Global. Precision-Driven.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
